<script setup>
defineOptions({
  inheritAttrs: true,
})
defineProps(['control-id'])
</script>
<template>
  <div class="card p-3 schema-field-layout" :id="controlId">
    <div class="h6" v-if="$slots.label"><slot name="label" /></div>
    <slot name="control" />
  </div>
</template>
